import { AxiosRequestConfig } from "axios";

export const makeAxiosRequestConfig = (): AxiosRequestConfig => {
  return { headers: { now: `${Date.now()}-${Math.random()}` } };
};
